// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".review-status-selector[data-v-4efdcfcf] .v-input__slot{min-height:32px !important;display:-webkit-box !important;display:-ms-flexbox !important;display:flex !important;-webkit-box-align:center !important;-ms-flex-align:center !important;align-items:center !important}.review-status-selector[data-v-4efdcfcf] .v-input__append-inner{margin-top:5px}", ""]);
// Exports
module.exports = exports;
